import type { CustomerOrder } from '../orders-api/types'

export const buildSupportRequestPath = (
  order: CustomerOrder,
  toLocalizedPath?: (path: string) => string,
) => {
  const query = new URLSearchParams()
  query.set('orderId', order.id)
  query.set('orderNumber', order.orderNumber)
  query.set('orderStatus', order.status)

  const firstProductName = order.items[0]?.productName?.trim()
  if (firstProductName) {
    query.set('productHint', firstProductName)
  }

  const path = `/dashboard/support?${query.toString()}`
  return toLocalizedPath ? toLocalizedPath(path) : path
}

export const createSupportRequestPathBuilder = (toLocalizedPath?: (path: string) => string) => {
  return (order: CustomerOrder) => buildSupportRequestPath(order, toLocalizedPath)
}
